export default __webpack_public_path__ + "static/media/Sierra-Logo.4c70b1f3.jpg";